<template>
  <vs-popup class="user-edit-popup" id="popup" title="CREATE CHANNEL PARTNER AGREEMENT FOR CUSTOMER" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <!-- <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="date_introduced" name="date_introduced" rules="required" v-slot="{ errors }">
                <small class="label">Date Introduced </small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden"
                  v-model="createStaffForm.date_introduced" placeholder="Choose Date" />
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                  v-model="createStaffForm.date_introduced" placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div> -->
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="percent" name="percent" rules="required" v-slot="{ errors }">
                <small class="label">Commission Percentage (%)</small>
                <vs-input v-model="createStaffForm.percent" name="percent" class="w-full required" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="start_date" name="start_date" rules="required" v-slot="{ errors }">
                <small class="label">Agreement Start Date </small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden"
                  v-model="createStaffForm.start_date" placeholder="Choose Date" />
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                  v-model="createStaffForm.start_date" placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="end_date" name="end_date" rules="required" v-slot="{ errors }">
                <small class="label">Agreement End Date</small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden"
                  v-model="createStaffForm.end_date" placeholder="Choose Date" />
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                  v-model="createStaffForm.end_date" placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner');
const CurrencyRepository = RepositoryFactory.get('currency');
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
const CountryCodeRepository = RepositoryFactory.get('countryCode');
const UserRepository = RepositoryFactory.get('user');
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

function initialState() {
  return {
    open: false,
    createStaffForm: {
      start_date: '',
      end_date: '',
      percent: ''
    },
    currencyList: {},
    countryCodes: [],
    account_handlers: [],
    tenant_id: null,
    customer_id: null,
  }
}

export default {
  name: 'CreateChannelPartnerAgreementPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
    flatPickr,
  },

  methods: {
    async openPopup(tenant_id, customer_id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.tenant_id = tenant_id
        this.customer_id = customer_id
        // await this.fetchCountryList()
        // await this.loadCountryCodes()
        // await this.fetchUsers()
        this.open = true;
      } catch (error) {
        console.log("error", error)
      }
    },

    async onClickCreateStaffUser() {
      const vue = this;
      this.$vs.loading()
      try {
        this.createStaffForm.percent = Number(this.createStaffForm.percent).toFixed(2)
        await ChannelPartnerRepository.cretaeChannelPartnerAgreemen(this.customer_id, {
          tenant_id: this.tenant_id,
          agreements: [
            this.createStaffForm
          ]
        })
        this.showSuccessMessage('Channel partner agreement created successfully')
        await this.$emit('refreshData')
        this.open = false;
      } catch (e) {
        console.log(e.message);
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchCountryList() {
      const { data } = await CurrencyRepository.getCurrencyList()
      this.currencyList = data.data
    },
    async loadCountryCodes() {
      const { data } = await CountryCodeRepository.get()
      this.countryCodes = data.data
    },
    async fetchUsers() {
      const { data } = (await UserRepository.get(1, '', 150, '')).data
      this.account_handlers = data
    },
    onClickReset() {
      this.createStaffForm = {}
    }
  },
}
</script>

<style scoped>
.video-wrapper {
  width: 100%;
  height: 100%;
}

.video-wrapper video {
  object-fit: cover;
  width: 100%;
  height: 100%;

}

.image-wrapper {
  width: 100%;
  height: 75%;
}
</style>
